module.exports = "//static.hsappstatic.net/LoginUI/static-1.13362/img/HubSpot-sprocket-color.png"